import { Navigate, useLocation, useParams } from 'react-router-dom';

export const RedirectToBuild = ({ path }: { path: string }) => {
  const { realm } = useParams<{ realm: string }>();
  const { search } = useLocation();

  return <Navigate replace to={`/${realm}/operation/build/${path}${search}`} />;
};
